export default "__VITE_ASSET__C$otbnWa__"